import React from 'react'

export default function Spinnar() {
  return (
	<>
		<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
		<span class="visually-hidden">Loading...</span>
	</>
  )
}
